import { ICellExportPusherEventPayload } from './cell-export-types';
import { ContentType } from '../notebook.types';
import { createAction, props } from '@ngrx/store';

export const initExportCell = createAction(
  '[Cell Export] InitExportCell',
  props<{
    cellToken: string;
    cellContentType: ContentType;
    datasetName: string;
  }>()
);

export const initExportCellSuccess = createAction(
  '[Cell Export] InitExportCellSuccess',
  props<{
    cellRunToken: string;
  }>()
);

export const exportCellInProgress = createAction(
  '[Cell Export] ExportCellRequestInProgress',
  props<{
    exportingCellToken: string;
    progressToastId: number;
  }>()
);

export const exportDataframeCompleted = createAction(
  '[Cell Export] ExportDataframeCompleted',
  props<{
    payload: ICellExportPusherEventPayload;
  }>()
);

export const initExportCellFailure = createAction(
  '[Cell Export] InitExportCellFailure',
  props<{
    error: Error;
  }>()
);

export const exportCellSuccess = createAction(
  '[Cell Export] ExportCellSuccess',
  props<{
    cellToken: string;
    queryToken: string;
    switchViewToken: string;
    localDatasetExportedAt: string;
    reportRunToken: string;
  }>()
);

export const exportCellFailure = createAction(
  '[Cell Export] ExportCellFailure',
  props<{
    error: Error;
  }>()
);

export const refreshDataViewsAfterExport = createAction(
  '[Cell Export] RefreshDataViewsAfterExport',
  props<{
    reportToken: string;
    exportedDatasetToken: string;
  }>()
);

export const refreshReportRunAfterCellRun = createAction(
  '[Cell Export] RefreshReportRunAfterCellRun',
  props<{
    reportToken: string;
    exportedDatasetToken: string;
  }>()
);

export const refreshDataViewAfterCellUpdate = createAction(
  '[Cell] RefreshDataViewAfterCellUpdate',
  props<{
    cellToken: string;
  }>()
);
